module.exports = __webpack_public_path__ + "img/money_coupon.164770b5.png";